import * as types from './types';

const INITIAL_STATE = {
    departTripId: undefined,
    returnTripId: undefined,
    seats: 1,
    wheelchairs: 0,
};

function setTravelerInfo(state, action) {
    const {
        payload: data,
    } = action;

    return {
        ...state,
        ...data,
    };
}

function resetTravelerInfo(state) {
    return {
        ...state,
        seats: INITIAL_STATE.seats,
        wheelchairs: INITIAL_STATE.wheelchairs,
    };
}

function setDepartTripId(state, action) {
    const {
        meta: departTripId,
    } = action;

    return {
        ...state,
        departTripId,
    };
}

function setReturnTripId(state, action) {
    const {
        meta: returnTripId,
    } = action;

    return {
        ...state,
        returnTripId,
    };
}

function removeTripIds(state) {
    return {
        ...state,
        departTripId: undefined,
        returnTripId: undefined,
    };
}

function setFareClass(state, action) {
    const {
        payload: fareClass,
    } = action;

    return {
        ...state,
        fareClass,
    };
}

const reducerFunctions = {
    [types.SET_TRAVELER_INFO]: setTravelerInfo,
    [types.RESET_TRAVELER_INFO]: resetTravelerInfo,
    [types.SET_DEPART_TRIP_ID]: setDepartTripId,
    [types.SET_RETURN_TRIP_ID]: setReturnTripId,
    [types.SET_FARE_CLASS]: setFareClass,
    [types.REMOVE_TRIP_IDS]: removeTripIds,
};

export default function reducer(state = INITIAL_STATE, action) {
    if (!reducerFunctions.hasOwnProperty(action.type)) {
        return state;
    }

    return reducerFunctions[action.type](state, action);
}
